import React, { useEffect, useState, useContext } from "react";
import { navigate } from "gatsby";
import { css } from "@emotion/react";
import Slider, { Settings } from "react-slick";
import "slick-carousel/slick/slick.css";
import "lazysizes";
import ViewerStateContext from "../context/viewer-state";
import { PublishedContext } from "../context/published-state";
import { devices } from "../assets/styles/variables";
import ComicSliderArrow from "./comicSliderArrow";
import ActionSlide from "./actionSlide";
import { pvListener } from "../utils/pvListener";
import withPublishedLimit from "./withPublishedLimit";
import StatusSlide from "./statusSlide";

const comicSlider = css`
  width: 100%;
  height: 100%;
  margin: 0 auto;

  @media screen and (min-width: ${devices.mobile}) {
    width: calc(100% - 220px);
  }

  .view {
    display: block;
    width: 100%;
    height: 100%;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }

  .slide {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    outline: none;
  }

  .image {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
  }
`;

const ComicSlider = (props: any) => {
  const { sliderRef, comic } = props;
  const pictureLength = comic.pictureUrls.length + 1;

  const viewerState = useContext(ViewerStateContext);
  const publishedState = useContext(PublishedContext)[0];

  const effectOfSlide = (target: number) => {
    const currentPage = pictureLength - target;
    // 2箇所への値の書き込み=副作用がある。
    // 画面遷移と、GoogleAnalyticsへの送信と。
    navigate(`/${comic.slug}/${comic.num}?page=${currentPage}`);
    pvListener(comic.slug, comic.num, currentPage, comic.media.gaIds);
  };

  const settings: Settings = {
    initialSlide: viewerState.currentPage - 1,
    dots: false,
    infinite: false,
    rtl: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: (
      <ComicSliderArrow
        isPrev={false}
        isShown={viewerState.currentPage !== pictureLength}
      />
    ),
    nextArrow: (
      <ComicSliderArrow isPrev={true} isShown={viewerState.currentPage > 1} />
    ),
    afterChange: (target: number) => {
      effectOfSlide(target);
    }
  };

  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    // SSR時の画面のちらつきを防ぐために、マウント後にスライダーを表示する
    setIsMounted(true);
  }, []);

  /**
   * Sliderに渡す子要素のうちの最終ページ。
   * ページ数の辻褄合わせのため、最終ページが表示されていない時でも空要素を渡す
   */
  const lastPageJSX = viewerState.currentPage === pictureLength ? <ActionSlide comic={comic} /> : <React.Fragment />;

  return (
    <div css={comicSlider}>
      {!publishedState.soon && !publishedState.late ? (
        isMounted && (
          <Slider ref={sliderRef} {...settings}>
            {comic.pictureUrls.map((pictureUrl: string, i: number) => (
              <div className="slide" key={i}>
                <img className="image lazyload" data-src={pictureUrl} alt="" />
              </div>
            ))}
            {lastPageJSX}
          </Slider>
        )
      ) : (
        <StatusSlide slug={comic.slug} />
      )}
    </div>
  );
};

export default withPublishedLimit(ComicSlider);
